export var ENTITY = "apportionment-key";
export var REDUCER_KEY = "APPORTIONMENT_KEYS_V2";
export var BASE_PATH_ENTITY = "apportionment-keys";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
